import React from 'react';
import { BOOKING_STEP_DATA_GRABS } from './constants';
import { OuterContainerBase } from './styles';

type OuterContainerProps = React.ComponentProps<typeof OuterContainerBase>;

const OuterContainer = ({ children, ...props }: OuterContainerProps) => {
    return (
        <OuterContainerBase
            {...props}
            data-grab={BOOKING_STEP_DATA_GRABS.selectionListWrapper}
        >
            {children}
        </OuterContainerBase>
    );
};

export default OuterContainer;
